import React from "react";
import deepakSharmaImg from "../../assets/images/webp/other/deepak-sharma-three-img.webp";
import BlueHeading from "../other/common/BlueHeading";
import CustomButton from "../other/common/CustomButton";

const HeroSecond = () => {
  return (
    <>
      <div className="flex items-center justify-center bg-cover bg-no-repeat bg-center bg-second-hero-bg">
        <div className="w-full max-w-[1140px] px-4 flex flex-col lg:flex-row items-center relative">
          <div className="py-[179px] max-xl:py-32 max-lg:py-12 max-md:py-10 max-w-[738px] w-full z-10">
            <BlueHeading
              lineClassOne="!bg-white"
              lineClassTwo="!bg-white"
              text="About Entrepreneur"
              textClass="!text-white"
            />
            <h2 className="text-6xl max-xl:text-[50px] max-lg:text-5xl max-md:text-4xl max-sm:text-3xl font-bold ff-jakarta leading-[120%] text-white pt-3 max-w-[738px]">
              Visionary Entrepreneur. Purpose-Driven Builder
            </h2>
            <p className="text-[#DDDDDD] font-normal text-base leading-[150%] pt-2">
              Founder of Makeway India Group | Real Estate & Hospitality
              Innovator
            </p>
            <CustomButton
              myClass="!text-black !bg-white mt-10 hover:!text-white hover:!bg-[#241DB6]"
              text="Explore Project"
            />
          </div>

          <div className="w-full max-w-[585px] h-[652px]  max-xl:h-[500px] max-lg:h-[400px] max-sm:h-[370px] lg:absolute lg:right-0 bottom-[-30px] max-xl:bottom-0 z-0">
            <img
              src={deepakSharmaImg}
              alt="deepak-sharma"
              width={585}
              height={652}
              className="w-full h-full object-contain"
            />
          </div>
        </div>
      </div>
    </>
  );
};

export default HeroSecond;
